import { Directive, ElementRef, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appLazyBackground]'
})
export class LazyBackgroundDirective implements OnInit, OnDestroy {

  @Input() appLazyBackground: string = '';
  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.createIntersectionObserver();
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appLazyBackground'] && !changes['appLazyBackground'].firstChange) {
      this.createIntersectionObserver();
    }
  }

  private createIntersectionObserver(): void {
    const options = {
      root: null, // use the viewport as the root
      threshold: 0.1 // trigger when at least 10% of the element is in the viewport
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.appLazyBackground) {
          // Set the background image once the element is in the viewport
          this.el.nativeElement.style.backgroundImage = `url(${this.appLazyBackground})`;
        }
        else {
          this.el.nativeElement.removeAttribute("style");
        }
        this.observer.unobserve(entry.target); // Stop observing once the background is set
      });
    }, options);

    // Start observing the element
    this.observer.observe(this.el.nativeElement);
  }
}